// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jJGB","footer":"styles_footer__2dQDN"};